require('../../scss/frontend/officePage.scss');

import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
require('mapbox-gl/dist/mapbox-gl.css');

$(document).ready(function () {
    mapboxgl.accessToken = 'pk.eyJ1Ijoib2ltbWVpIiwiYSI6ImNsd2l6N2RydjBwdTIya293aTkyMmgxNmsifQ.n9BMEe1VINjZWpDBthzWSA';

    $('#contact_requestType').change(function () {
        $('#contact_requestType option[value=""]').remove();
    });

    const office = $('#office-page-map').data('office');

    const officePageMap = new mapboxgl.Map({
        container: 'office-page-map',
        // Choose from Mapbox's core styles, or make your own style with Mapbox Studio
        // style: 'mapbox://styles/mapbox/outdoors-v12',
        zoom: 16,
        center: [office.latLng.coordinates[0], office.latLng.coordinates[1]],
        projection: 'globe',
        scrollZoom: false,
    });

    const el = document.createElement('div');
    el.className = 'marker';

    // make a marker for each feature and add to the map
    new mapboxgl.Marker(el).setLngLat([office.latLng.coordinates[0], office.latLng.coordinates[1]]).addTo(officePageMap)
});

